import * as Constants from '../constants/Constants';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const saveResumeActivityCookie = (
  activityName,
  projectId,
  gsku,
  projectCategory,
  dirtyFlag,
  CCT
) => {
  const value = JSON.stringify({
    activity: activityName,
    projectId,
    gsku,
    projectCategory,
    disposition: dirtyFlag,
    CCT
  });
  cookies.set(Constants.ACTIVITY_COOKIE_NAME, value, {
    path: '/',
    maxAge: 3600 * 24 * 15,
    domain: window.location.href.hostname
  });
};

export const saveFeedbackActivityCookie = activityName => {
  cookies.set(`HPAC_${activityName}`, {
    path: '/',
    // maxAge: 3600 * 24 * 60,
    domain: window.location.href.hostname
  });
};

export const removeActivityCookie = () => {
  cookies.remove(Constants.ACTIVITY_COOKIE_NAME, {
    path: '/',
    maxAge: 3600 * 24 * 14,
    domain: window.location.href.hostname
  });
};

export const resumeActivityCookieProjectId = () => {
  const cookie = cookies.get(Constants.ACTIVITY_COOKIE_NAME);
  if (cookie) {
    return cookie.projectId;
  }
  return null;
};

export const resumeActivityCookieProjectCategory = () => {
  const cookie = cookies.get(Constants.ACTIVITY_COOKIE_NAME);
  if (cookie) {
    return cookie.projectCategory;
  }
  return null;
};

export const resumeActivityCookieGsku = () => {
  const cookie = cookies.get(Constants.ACTIVITY_COOKIE_NAME);
  if (cookie) {
    return cookie.gsku;
  }
  return null;
};

export const resumeFeedbackCookie = feedbackCookie => {
  const cookie = cookies.get(`HPAC_${feedbackCookie}`);
  if (cookie) {
    return cookie;
  }
  return null;
};

export const resumeActivityCookieActivity = () => {
  const cookie = cookies.get(Constants.ACTIVITY_COOKIE_NAME);
  if (cookie) {
    return cookie.activity;
  }
  return null;
};

export const savePrinitingOptionKey = (prinitingOption, storeId) => {
  const value = JSON.stringify({
    RIP: prinitingOption,
    storeId
  });
  cookies.set(Constants.PRINITING_OPTION_COOKIE_NAME, value, {
    path: '/',
    maxAge: 3600 * 24 * 15,
    domain: window.location.href.hostname
  });
};

export const getPrinitingOptionKey = storeId => {
  const cookie = cookies.get(Constants.PRINITING_OPTION_COOKIE_NAME);
  if (cookie) {
    if (cookie.storeId === storeId) {
      return cookie.RIP;
    }
  }

  return null;
};

export const saveLanguageKey = (langCode, storeId) => {
  const value = JSON.stringify({
    language: langCode,
    storeId
  });
  cookies.set(Constants.LANGUAGE_CODE, value, {
    path: '/',
    maxAge: 3600 * 24 * 15,
    domain: window.location.href.hostname
  });
};

export const getLanguageKey = storeId => {
  const cookie = cookies.get(Constants.LANGUAGE_CODE);
  if (cookie) {
    if (cookie.storeId === storeId) {
      return cookie.language;
    }
  }
  return null;
};

export const saveDocumentColorsCookie = documentColors => {
  const value = JSON.stringify({
    colors: documentColors
  });
  cookies.set(Constants.DOCUMENT_COLORS_SAVE_ACTIVITY, value, {
    path: '/',
    domain: window.location.href.hostname
  });
};

export const resumeDocumentColorsCookieActivity = () => {
  const cookie = cookies.get(Constants.DOCUMENT_COLORS_SAVE_ACTIVITY);
  if (cookie) {
    return cookie.colors;
  }
  return null;
};

export const removeDocumentColorsCookie = () => {
  cookies.remove(Constants.DOCUMENT_COLORS_SAVE_ACTIVITY, {
    path: '/',
    maxAge: 3600 * 24 * 14,
    domain: window.location.href.hostname
  });
};
